import React, { Fragment, useEffect, useState } from "react";
import 'react-toastify/dist/ReactToastify.css';
import { Link , useNavigate } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
import { MaterialReactTable } from 'material-react-table'
import type { ColumnFiltersState, PaginationState } from '@tanstack/react-table';
import { PAGES } from '../../Constants/CommonConstants';
import { paginationQuery, handleSearch } from '../../utils/GlobalHelper';
import { getDate } from '../../utils/Helper';
import { StaffGetAction } from "../../Redux/Action/StaffAction";

function StaffManagement() {
  const [data, setData] = useState<any>([]);

    const dispatch = useDispatch<any>();
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
    const [sorting, setSorting] = useState<any>(['DESC']);
    const Stafflist = useSelector((state: any) => state.StaffGetState);

  
  const [pagination, setPagination] = useState<PaginationState>({
      pageIndex: PAGES?.pageIndex,
      pageSize: PAGES?.pageSize
    });
    const [searchValue, setSearchValue] = useState('');
    const [rowCount, setRowCount] = useState(0);
    const log_in = useSelector((state: any) => state.AdminLogInState)

 useEffect(() => {
  const fetchData = async () => {
    if (!data?.length) {
      setLoading(true);
    } else {
      setIsRefetching(true);
    }
    try {
      let query: any = paginationQuery(
        pagination.pageIndex,
        pagination.pageSize,
        sorting,
        searchValue,
        columnFilters
      );

      await dispatch(StaffGetAction(query));

    } catch (error) {
      setIsError(true);
      return;
    }
    setIsError(false);
    setLoading(false);
    setIsRefetching(false);
  };
  fetchData();
}, [
  columnFilters,
  searchValue,
  pagination.pageIndex,
  pagination.pageSize,
  sorting
]);
useEffect(() => {
  setData(Stafflist?.data?.data?.rows);
  setRowCount(Stafflist?.data?.data?.count);
}, [Stafflist?.data]);

 const columns: any = [
  {
    accessorKey: 'S.NO',
    header: 'S.NO',
    accessorFn: (row: Object, index: number) => {
      const currentPage = pagination.pageIndex + 1 || 1;
      const itemsPerPage = pagination.pageSize || 10; 
      const startIndex = (currentPage - 1) * itemsPerPage;
      const serialNumber = startIndex + index + 1;
      return serialNumber;
    },
    enableSorting: false,
    enableColumnOrdering: false,
    enableColumnDragging: false,
    enableColumnFilter: false,
    size:50,
},
  {
    accessorKey: 'name',
    header: 'Name',
    enableSorting: false,
    enableColumnOrdering: false,
    enableColumnDragging: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'email',
    header: 'Email',
    enableSorting: false,
    enableColumnOrdering: false,
    enableColumnDragging: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'phone_number',
    header: 'Mobile',
    enableSorting: false,
    enableColumnOrdering: false,
    enableColumnDragging: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'country',
    header: 'Adders',
    enableSorting: false,
    enableColumnOrdering: false,
    enableColumnDragging: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'bio',
    header: 'Services',
    enableSorting: false,
    enableColumnOrdering: false,
    enableColumnDragging: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'id',
    header: 'Total Done Services',
    enableSorting: false,
    enableColumnOrdering: false,
    enableColumnDragging: false,
    enableColumnFilter: false
  },
 
  {
    accessorKey: 'created_at',
    header: 'Created At',
    accessorFn: (row: { created_at: any; }) => getDate(row.created_at),
    size: 150,
    filterVariant: 'date',
    enableSorting: false,
    enableColumnOrdering: false,
    enableColumnDragging: false,
    enableColumnFilter: false,
  },
];



    return (
        <Fragment>
            { loading || Stafflist?.loading ? <Spinner /> : ""}
            <PageLayout
        title="Staff Management"
        breadcrumbs={{
          secLast: { 'link': '/staff-list', 'name': 'Staff Management' },
        }}
        buttons={[
          { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
        ]}
      >

     
      <div className="row gy-3 mb-3">
          <div className="col-md-6 ms-auto text-end"> 
          </div>
        </div>
        {
          data &&
          <MaterialReactTable

            columns={columns}
            data={data}
            enableGlobalFilter={false}

            enableHiding={false}
            enableColumnFilters={false}
            enableDensityToggle={false}
            enableColumnActions={false}
            enableFullScreenToggle={false}
            positionToolbarAlertBanner="top"
            initialState={{ showColumnFilters: false }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={isError ? { color: 'error', children: 'Error loading data', } : undefined}
            muiSearchTextFieldProps={{
              placeholder: 'Search from name',
            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={(value: any) => handleSearch(
              value,
              setIsError,
              setLoading,
              setIsRefetching,
              setSearchValue,
            )
            }
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        }      
            <ToastDefault />
            </PageLayout>
        </Fragment>
    );
}

export default StaffManagement;